import type { ISessionRepository, SessionListOptions } from '../repositories/ISessionRepository.js';
import type { SessionEntity } from '../entities/SessionEntity.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createListSessionsUseCase({ sessionRepository }: Deps) {
  return async function listSessions(options: SessionListOptions): Promise<{ data: SessionEntity[]; total: number }> {
    return sessionRepository.list(options);
  };
}
